(() => {
  const root = document.documentElement;
  const design = root.classList.contains('shopify-design-mode');
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* En-tete : reduction douce au defilement */
  const header = document.querySelector('[data-bm-header]');
  if (header) {
    let ticking = false;
    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* Apparition progressive (desactivee si mouvement reduit ou editeur) */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!design && !reduce && 'IntersectionObserver' in window) {
    const els = Array.from(document.querySelectorAll('[data-bm-reveal]'));
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });
    root.classList.add('bm-js');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.filter((el) => !el.classList.contains('is-in')).forEach((el) => io.observe(el));
  }

  /* Ajout rapide au panier (API Ajax Shopify) */
  const live = document.querySelector('[data-bm-live]');
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-bm-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add');
      const cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-bm-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      btn.textContent = btn.dataset.done || 'Ajouté';
      btn.classList.add('is-done');
      if (live) live.textContent = btn.dataset.done || 'Ajouté au panier';
    } catch (e) {
      btn.textContent = btn.dataset.error || 'Réessayer';
    } finally {
      btn.classList.remove('is-loading');
      setTimeout(() => {
        btn.textContent = label;
        btn.classList.remove('is-done');
        btn.disabled = false;
      }, 2200);
    }
  });
})();
